// removed by extract-text-webpack-plugin
module.exports = {"info":"styles__info___1HC4J","infoItem":"styles__infoItem___72gXC","infoItemLabel":"styles__infoItemLabel___2siRm","infoMap":"styles__infoMap___T8zc3"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/info/styles.css
// module id = SLLz
// module chunks = 2